// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.clearAll {
  clear: both;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.noMarginTop {
  margin-top: 0x !important;
}

.backOverlay .button {
  width: 100%;
}

.backOverlay > .primary {
  width: 100%;
}

.backOverlay {
  padding: 20px;
  margin: 5px;
  border-radius: 10px;
  background: white;
  padding-top: 60px;
  padding-bottom: 60px;
}

.overlayPrompt {
  box-shadow: 0px 0px 0px 4000px rgba(27, 61, 88, 0.5) inset;
  overflow-y: scroll;
}

.overlayLight {
  background: rgba(217, 217, 217, 0.47) !important;
}

.formDiv-filter {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: text;
  border-radius: 4px;
  background-color: #fff;
  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;
  height: 56px;
  width: 100%;
  position: relative;
  border: 1px solid #E1E1E1;
  border-radius: 6px;
  margin: 5px;
}

.formDiv-filter label {
  position: absolute;
  top: 18px;
  left: 0;
  color: grey;
  pointer-events: none;
  transition: all 0.3s ease;
  text-indent: 10px;
  line-height: 22px;
  font-size: 17px;
}

.formDiv-filter input {
  height: 100%;
  width: 100%;
  padding: 2px;
  border: none;
  font-size: 0.9rem;
  text-indent: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  padding-top: 16px;
  background-color: transparent;
}

.formDiv-filter input:focus {
  border: none;
  outline: none;
}

.formDiv-filter label.hasValue,
.formDiv-filter:focus-within label {
  transform: translateY(-10px);
  font-size: 12px;
  line-height: 16px;
}

.formDiv-filter.hasError {
  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);
  background-color: rgba(204, 48, 68, 0.07);
}

.formDiv-filter .react-datepicker__input-container {
  position: unset;
}

.calendarIconContainer svg.calendarIcon {
  width: 20px;
  height: 20px;
}
.calendarIconContainer svg.calendarIcon g path {
  stroke: #717171;
}
.calendarIconContainer .calendarIconContainer {
  top: 50%;
  transform: translateY(-50%);
}

.calendarIconContainerClose svg.calendarIconClose {
  width: 20px;
  height: 20px;
}
.calendarIconContainerClose svg.calendarIconClose path {
  stroke: #717171;
  fill: #717171;
}
.calendarIconContainerClose .calendarIconContainerClose {
  top: 50%;
  transform: translateY(-50%);
}

.position-close-icon {
  right: 50px;
  bottom: 10px;
}

.multi-select {
  width: 60%;
}

.pt-60 {
  padding-top: 60px;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,0DAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gDAAA;AACJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;AAAJ;;AAGA;;EAEI,4BAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,kDAAA;EACA,yCAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAKI;EACI,WAAA;EACA,YAAA;AAFR;AAKI;EACI,eAAA;AAHR;AAMI;EACI,QAAA;EACA,2BAAA;AAJR;;AASI;EACI,WAAA;EACA,YAAA;AANR;AAUI;EACI,eAAA;EACA,aAAA;AARR;AAWI;EACI,QAAA;EACA,2BAAA;AATR;;AAaA;EACI,WAAA;EACA,YAAA;AAVJ;;AAaA;EACI,UAAA;AAVJ;;AAaA;EACI,iBAAA;AAVJ","sourcesContent":[".header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.clearAll {\n  clear: both;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.noMarginTop {\n  margin-top: 0x !important;\n}\n\n.backOverlay .button {\n  width: 100%;\n}\n\n.backOverlay > .primary {\n  width: 100%;\n}\n\n.backOverlay {\n  padding: 20px;\n  margin: 5px;\n  border-radius: 10px;\n  background: white;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.overlayPrompt {\n  box-shadow: 0px 0px 0px 4000px rgba(27, 61, 88, 0.5) inset;\n  overflow-y: scroll;\n}\n\n.overlayLight {\n  background: rgba(217, 217, 217, 0.47) !important;\n}\n\n.formDiv-filter {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  cursor: text;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;\n  height: 56px;\n  width: 100%;\n  position: relative;\n  border: 1px solid #E1E1E1;\n  border-radius: 6px;\n  margin: 5px;\n}\n\n.formDiv-filter label {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  color: grey;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  text-indent: 10px;\n  line-height: 22px;\n  font-size: 17px;\n}\n\n.formDiv-filter input {\n  height: 100%;\n  width: 100%;\n  padding: 2px;\n  border: none;\n  font-size: 0.9rem;\n  text-indent: 10px;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding-top: 16px;\n  background-color: transparent;\n}\n\n.formDiv-filter input:focus {\n  border: none;\n  outline: none;\n}\n\n.formDiv-filter label.hasValue,\n.formDiv-filter:focus-within label {\n  transform: translateY(-10px);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.formDiv-filter.hasError {\n  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);\n  background-color: rgba(204, 48, 68, 0.07);\n}\n\n.formDiv-filter .react-datepicker__input-container {\n  position: unset;\n}\n\n.calendarIconContainer svg.calendarIcon {\n  width: 20px;\n  height: 20px;\n}\n.calendarIconContainer svg.calendarIcon g path {\n  stroke: #717171;\n}\n.calendarIconContainer .calendarIconContainer {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.calendarIconContainerClose svg.calendarIconClose {\n  width: 20px;\n  height: 20px;\n}\n.calendarIconContainerClose svg.calendarIconClose path {\n  stroke: #717171;\n  fill: #717171;\n}\n.calendarIconContainerClose .calendarIconContainerClose {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.position-close-icon {\n  right: 50px;\n  bottom: 10px;\n}\n\n.multi-select {\n  width: 60%;\n}\n\n.pt-60 {\n  padding-top: 60px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
